var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 30.4397L26.8263 25.2669C28.209 23.4872 28.8614 21.2475 28.6507 19.0036C28.4399 16.7597 27.3819 14.6807 25.692 13.1896C24.002 11.6985 21.8073 10.9076 19.5546 10.978C17.302 11.0483 15.1609 11.9746 13.5672 13.5682C11.9736 15.1618 11.0473 17.3029 10.977 19.5554C10.9066 21.808 11.6975 24.0028 13.1886 25.6927C14.6797 27.3826 16.7588 28.4408 19.0027 28.6515C21.2466 28.8622 23.4863 28.2099 25.266 26.8271L30.44 32L32.0003 30.4397ZM19.8625 26.4829C18.5531 26.4829 17.273 26.0945 16.1842 25.3671C15.0955 24.6396 14.247 23.6056 13.7458 22.3959C13.2447 21.1862 13.1136 19.855 13.369 18.5707C13.6245 17.2864 14.255 16.1068 15.181 15.1808C16.107 14.2549 17.2866 13.6244 18.5709 13.3689C19.8552 13.1135 21.1864 13.2446 22.3961 13.7457C23.6058 14.2468 24.6399 15.0954 25.3674 16.184C26.0948 17.2729 26.4832 18.5529 26.4832 19.8623C26.4811 21.6175 25.7829 23.3004 24.5417 24.5414C23.3006 25.7827 21.6177 26.4808 19.8625 26.4829Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62065 26.4823H2.20688C1.62177 26.4818 1.06077 26.249 0.647023 25.8353C0.233287 25.4216 0.000579086 24.8606 0 24.2755V19.8618H2.20688V24.2755H6.62065V26.4823Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0343H2.20688V15.448H0V11.0343Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4829 6.62059H24.2761V2.20686H19.8623V0H24.2761C24.8612 0.000579081 25.4222 0.233285 25.8359 0.647017C26.2496 1.06076 26.4824 1.62175 26.4829 2.20686V6.62059Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0344 0H15.4482V2.20686H11.0344V0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20688 6.62059H0V2.20686C0.000579086 1.62175 0.233287 1.06076 0.647023 0.647017C1.06077 0.233285 1.62177 0.000579081 2.20688 0H6.62065V2.20686H2.20688V6.62059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ec2febd0dc4b4369ea999eae88bab98f.svg";
export { ForwardRef as ReactComponent };